import React from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const events = [
  {
    title: "Interview with Adekunle Samuel",
    start: new Date(2025, 9, 23, 10, 0),
    end: new Date(2025, 9, 23, 11, 0),
    color: "#E4F5FF",
  },
  {
    title: "Interview with Charles Emeka",
    start: new Date(2025, 9, 23, 12, 0),
    end: new Date(2025, 9, 23, 13, 0),
    color: "#FFF3D0",
  },
  {
    title: "Interview with Bose Gold",
    start: new Date(2025, 9, 23, 15, 0),
    end: new Date(2025, 9, 23, 16, 0),
    color: "#F9F5FF",
  },
];

// Helper function to darken hex color
function darkenHex(hex, amount = 20) {
  let c = hex.replace("#", "");
  if (c.length === 3) c = c.split("").map((x) => x + x).join("");
  let num = parseInt(c, 16);
  let r = Math.max(0, (num >> 16) - amount);
  let g = Math.max(0, ((num >> 8) & 0x00FF) - amount);
  let b = Math.max(0, (num & 0x0000FF) - amount);
  return `rgb(${r},${g},${b})`;
}

// Custom event component
const CustomEvent = ({ event }) => {
  const titleColor = darkenHex(event.color, 40); // darken the background for the title

  return (
    <div
      style={{
        backgroundColor: event.color,
        borderRadius: "6px",
        border: "0",
        padding: "6px 10px",
        fontSize: "13px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
    >
      {event.title ? (
        <div style={{ fontWeight: "600", color: titleColor, whiteSpace:"nowrap" }}>{event.title}</div>
      ) : (
        <hr
          style={{
            border: "none",
            borderTop: "1px solid #ccc",
            margin: "4px 0",
          }}
        />
      )}
      <div style={{ fontSize: "12px", color: titleColor, marginTop: "2px" }}>
        {moment(event.start).format("hh:mm a")} – {moment(event.end).format("hh:mm a")}
      </div>
    </div>
  );
};


export const HRManagerAgenda = () => {
  const today = new Date(2025, 9, 23);

  return (
    <div style={{ height: "auto", padding: "0" }}>

          <div className="flex space-between" style={{ textAlign: "center", marginBottom: "40px", fontSize: "12px", fontWeight: "normal" }}>
            <span style={{fontWeight:"bold"}}>{moment(today).format("dddd, MMM D")}</span>
            <span className='secondary-color'>See calendar</span>
    </div>

      <Calendar
        localizer={localizer}
        events={events}
        date={today}
        defaultView={Views.DAY}
        views={{ day: true }}
        toolbar={false}
        step={60}
        timeslots={1}
        min={new Date(2025, 9, 23, 9, 0)}
        max={new Date(2025, 9, 23, 17, 0)}
        components={{
          event: CustomEvent,
        }}
        formats={{
          timeGutterFormat: (date, culture, localizer) =>
            localizer.format(date, "hh:mm a", culture),
        }}
        eventPropGetter={(event) => ({
          style: {
            backgroundColor: event.color,
            border: "none",
            boxShadow: "none",
            padding: "0",
          },
        })}
      />

      <style>{`
        .rbc-event .rbc-event-label { display: none !important; }
        .rbc-time-view { border: none !important; background: #fff; }
        .rbc-time-header { display: none !important; }
        .rbc-timeslot-group { border-bottom: 1px solid #f1f1f1; min-height: 35px; }
        .rbc-time-content { border: none !important; }
        .rbc-time-gutter .rbc-timeslot-group { border: none; }
        .rbc-time-gutter {
          width: 70px;
          text-align: right;
          padding-right: 20px;
          font-size: 12px;
          color: #888;
        }
        .rbc-time-slot { border: none !important; }
        .rbc-event { box-shadow: none !important; }
      `}</style>
    </div>
  );
};
